import React, { Fragment } from 'react';
import { Catalog as CatalogDict } from '@/shared/i18n';
import { EventBus } from '@/shared/utils';
import { CatalogEvents } from '../../events';
import { CatalogViewData } from '../../types/catalog-view-data';
import { ICourseData, CourseDataOrResponse } from '../../types/course-data';
import { CatalogSection } from '../common/catalog-section';
import { normalizeCourseData } from '../../utils/api-helpers';
import { log } from 'console';

interface CourseListProps {
  dict: CatalogDict;
  filteringCatalogData: boolean;
  loadingCatalogData: boolean;
  eventBus: EventBus<CatalogEvents>;
  filteredItems: CourseDataOrResponse[] | unknown;
  categories: CatalogViewData['categories'];
  lastCourseElementRef: (node: HTMLElement | null) => void;
  onFavoriteChange?: (courseId: string, favouriteId: string | undefined) => void;
  isEnrichingData?: boolean;
  useSkeleton?: boolean; // New prop to use skeleton instead of spinner
}

export const CourseList: React.FC<CourseListProps> = ({
  dict,
  filteringCatalogData,
  loadingCatalogData,
  filteredItems,
  categories,
  lastCourseElementRef,
  eventBus,
  onFavoriteChange,
  isEnrichingData = false,
  useSkeleton = false, // Default to spinner for backwards compatibility
}) => {
  // Normalize the data to handle inconsistent API responses
  const filteredItemsData = normalizeCourseData(filteredItems);
  if (filteringCatalogData) {
    return (
      <CatalogSection
        type="grid"
        title="Elenco risultati"
        items={filteredItemsData}
        filteringCatalogData={filteringCatalogData}
        lastCourseElementRef={lastCourseElementRef}
        loadingCatalogData={loadingCatalogData}
        eventBus={eventBus}
        onFavoriteChange={onFavoriteChange}
        isEnrichingData={isEnrichingData}
        useSkeleton={useSkeleton} // Pass the skeleton flag
      />
    );
  }

  return (
    <>
      {categories &&
        Object.keys(categories).map((categoryKey, categoryIndex: number) => {
          const data = categories[categoryKey as keyof typeof categories];
          return (
            <Fragment key={categoryIndex}>
              {data?.items?.length > 0 && (
                <CatalogSection
                  eventBus={eventBus}
                  type="slider"
                  title={data.categoryTitle}
                  hasLink={data.hasControls}
                  route={data.route}
                  hasNavigationButtons={data.hasNavigationControls}
                  items={data?.items}
                  higlightItems={data?.highlighted}
                  onFavoriteChange={onFavoriteChange}
                  isEnrichingData={isEnrichingData}
                  loadingCatalogData={loadingCatalogData}
                  useSkeleton={useSkeleton} // Pass the skeleton flag
                />
              )}
            </Fragment>
          );
        })}
    </>
  );
};
